import React from 'react';
import {withRouter} from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import {Nav, Row, Col} from "react-bootstrap";
import style from './Menu.module.scss';
import * as propertyActions from "../../redux/action/property.action";
import {connect} from "react-redux";
import * as functions from "../../helper/functions";
import homeLogo from "../../asset/images/icon/logo.svg";
import {ADMIN_PANEL} from "../../environment/environment";

class Menu extends React.Component{
  redirect(to, type) {
    if (type) {
      const paths = functions.getFilterName();
      if(paths[0] === 'advanced-search') {
        this.props.setTransactionType(type);
      } else {
        this.props.history.push(to);
      }
    }
    else {
      this.props.history.push(to);
    }
  }

  render() {
    const { logo = true } = this.props;

    return (
        <React.Fragment>
          <Row className={`d-none d-md-flex align-items-center m-0 ${style.nav_container}`}>
            <Col className={'p-0'}>
              <Nav>
                <Nav.Link className={`${style.nav_items} ${style.login_advisor}`} onClick={() =>{
                  window.location = ADMIN_PANEL;
                }}>ورود مشاور</Nav.Link>
                <Nav.Link className={`${style.nav_items} ${style.add_property}`} onClick={() => {
                  this.redirect('/add-property')
                }}>ثبت آگهی ملک</Nav.Link>
              </Nav>
            </Col>
            <Col className={`p-0 text-right`}>
              <Nav className={`justify-content-end`}>
                <Nav.Link className={`${style.nav_items}`} onClick={() => {
                  this.redirect('/contact-us')
                }}>تماس با ما</Nav.Link>
                <Nav.Link className={`${style.nav_items}`} onClick={() => {
                  this.redirect('/about-us')
                }}>درباره ما</Nav.Link>
                <Nav.Link className={`${style.nav_items}`} onClick={() => {
                  this.redirect('/advanced-search?transactionType=RENT', 'RENT');
                }}>رهن و اجاره</Nav.Link>
                <Nav.Link className={`${style.nav_items}`} onClick={() => {
                  this.redirect('/advanced-search?transactionType=SELL', 'SELL');
                }}>خرید</Nav.Link>
                {
                  logo && (
                      <Nav.Link className={`${style.nav_items} ${style.last}`} onClick={() => {
                        this.redirect('/');
                      }}>
                        <img src={homeLogo} alt="HomePelak" width={80} height={30} />
                      </Nav.Link>
                  )
                }
              </Nav>
            </Col>
          </Row>
          <Navbar collapseOnSelect expand="md" className={`pl-0 pr-0 d-flex d-md-none`}>
            <Navbar.Brand className={`${style.nav_brand}`}>
              <img src={homeLogo} width={'140'} height={'50'} alt="Logo" onClick={() => {
                this.redirect('/');
              }} />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className={`${style.menuContainer}`}>
                <Nav.Link onClick={() => {
                  this.redirect('/')
                }}>صفحه اصلی</Nav.Link>
                <Nav.Link onClick={() => {
                  this.redirect('/advanced-search?transactionType=SELL', 'SELL');
                }}>خرید</Nav.Link>
                <Nav.Link onClick={() => {
                  this.redirect('/advanced-search?transactionType=RENT', 'RENT');
                }}>رهن و اجاره</Nav.Link>
                <Nav.Link onClick={() => {
                  this.redirect('/add-property')
                }}>ثبت آگهی ملک</Nav.Link>
                <Nav.Link onClick={() => {
                  this.redirect('/about-us')
                }}>درباره ما</Nav.Link>
                <Nav.Link onClick={() => {
                  this.redirect('/contact-us')
                }}>تماس با ما</Nav.Link>
                <Nav.Link onClick={() =>{
                  window.location = ADMIN_PANEL;
                }}>ورود مشاور</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  setTransactionType: (propertyType) => dispatch(propertyActions.setTransactionType(propertyType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Menu));
